'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Seleccionar hora'
};

exports['default'] = locale;